import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function AgencyDemo() {
  return (
    <section
      id="demo"
      data-testid="agency-demo"
      className="relative py-20 lg:py-28 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10">
        <div
          className="relative overflow-hidden rounded-[2rem] lg:rounded-[2.5rem] p-8 sm:p-14 lg:p-20 ring-1 ring-white/10"
          style={{
            background:
              "radial-gradient(ellipse 60% 80% at 100% 0%, rgba(251, 191, 36, 0.22), transparent 65%), radial-gradient(ellipse 60% 80% at 0% 100%, rgba(251, 191, 36, 0.08), transparent 65%), linear-gradient(135deg, rgba(255,255,255,0.04), rgba(255,255,255,0.01))",
          }}
        >
          {/* decorative grid */}
          <div
            aria-hidden="true"
            className="pointer-events-none absolute inset-0 opacity-30"
            style={{
              backgroundImage:
                "radial-gradient(circle at 1px 1px, rgba(255,255,255,0.05) 1px, transparent 0)",
              backgroundSize: "24px 24px",
            }}
          />

          <div className="relative grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div>
              <div className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-yellow">
                Zobacz na żywo
              </div>
              <h2 className="mt-3 font-heading font-extrabold text-white text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
                Tak może wyglądać strona{" "}
                <span className="text-brand-yellow">Twojej firmy.</span>
              </h2>
              <p className="mt-5 text-base sm:text-lg text-white/70 max-w-md leading-relaxed">
                Otwórz na telefonie — to tam się dzieje sprzedaż.
              </p>

              <Link
                to="/przyklad-strony"
                data-testid="agency-demo-cta"
                className="mt-9 inline-flex items-center justify-center h-14 px-7 rounded-full bg-brand-yellow hover:bg-brand-yellowHover text-brand-yellowFg font-semibold text-base shadow-lg hover:shadow-xl hover:scale-[1.02] active:scale-95 transition-all"
              >
                Otwórz przykład strony
                <ArrowUpRight className="ml-2 h-5 w-5" />
              </Link>
            </div>

            <div className="relative">
              {/* phone mockup */}
              <div className="relative mx-auto w-[240px] sm:w-[280px] aspect-[9/19] rounded-[2.5rem] bg-[#0B0F1A] ring-2 ring-white/15 shadow-2xl p-2.5">
                <div className="absolute top-3 left-1/2 -translate-x-1/2 h-5 w-24 rounded-full bg-black/80 z-10" />
                <div className="relative h-full w-full rounded-[2rem] overflow-hidden bg-gradient-to-b from-[#1E3A8A] via-white to-white">
                  <div className="pt-10 px-4">
                    <div className="flex items-center gap-2">
                      <div className="h-6 w-6 rounded-full bg-brand-yellow" />
                      <div className="h-2.5 w-16 rounded bg-white/70" />
                    </div>
                    <div className="mt-6 space-y-2">
                      <div className="h-3.5 w-[80%] rounded bg-white/85" />
                      <div className="h-3.5 w-[65%] rounded bg-white/70" />
                      <div className="h-3.5 w-[55%] rounded bg-brand-yellow/90" />
                    </div>
                    <div className="mt-4 h-10 rounded-xl bg-white shadow-md" />
                    <div className="mt-2 h-10 rounded-xl bg-brand-yellow shadow-md" />
                    <div className="mt-5 h-32 rounded-2xl bg-gradient-to-br from-slate-300 to-slate-500 shadow-inner" />
                    <div className="mt-3 space-y-1.5">
                      <div className="h-2 w-[70%] rounded bg-slate-400" />
                      <div className="h-2 w-[50%] rounded bg-slate-300" />
                    </div>
                  </div>
                </div>
              </div>

              {/* floating tag */}
              <div className="hidden sm:block absolute -right-2 lg:-right-6 top-8 rounded-2xl bg-white text-[#0B0F1A] px-4 py-2.5 shadow-xl ring-1 ring-black/5">
                <div className="text-[10px] font-bold uppercase tracking-wider text-emerald-600">
                  Nowy lead
                </div>
                <div className="text-sm font-semibold">+48 600 000 000</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
